import { ExtendedProjectPhase, ExtendedPropertyType, hasDatePassed } from '@bpd-library/utilities';

export const isProjectPhaseSubscribable = ({
    mainImage,
    status,
    propertyTypes,
    allocationDate,
}: ExtendedProjectPhase) => {
    if (!mainImage?.url || !propertyTypes?.length) return false;
    if (status !== 'InPreparation' && status !== 'OnSale') return false;
    if (allocationDate && hasDatePassed(allocationDate)) return false;
    return true;
};

export const isPropertyTypeSubscribable = ({ mainImage }: ExtendedPropertyType) => !!mainImage;
